module.exports = __webpack_public_path__ + "static/media/level1.0f296b4f.jpg";